import React, { useEffect, useState } from "react";
import AccountLayout from "./AccountLayout";
import { t } from "i18next";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import NoData from "../../component/NoData";
import { isEmpty } from "lodash";
import moment from "moment";
import { fi } from "date-fns/locale";

const Turnover = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({
    status: "active",
    page: 1,
    limit: 100,
  });

  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getTurnover, filter);
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
      }
    }
  };

  useEffect(() => {
    getData();
  }, [filter?.status]);

  return (
    <AccountLayout title={t("Turnover")}>
      <ng-component className="ng-star-inserted">
        <router-outlet />
        <ng-component
          _nghost-serverapp-c2794537353
          className="ng-tns-c2794537353-13 ng-star-inserted"
        >
          <div
            _ngcontent-serverapp-c2794537353
            className="player-top ng-tns-c2794537353-13"
          >
            <div
              _ngcontent-serverapp-c2794537353
              className="tab-btn-section ng-tns-c2794537353-13"
            >
              <app-tab-button-nav
                _ngcontent-serverapp-c2794537353
                className="ng-tns-c2794537353-13"
                _nghost-serverapp-c1328719065
              >
                <div
                  _ngcontent-serverapp-c1328719065
                  className="tab-btn tab-btn-page"
                >
                  <div
                    _ngcontent-serverapp-c1328719065
                    className="line"
                    style={{
                      width: "calc(50%)",
                      transform:
                        filter?.status !== "active"
                          ? "translate(100%, 0px)"
                          : "translate(0%, 0px)",
                    }}
                  />
                  <div
                    _ngcontent-serverapp-c1328719065
                    onClick={() => {
                      setFilter({
                        ...filter,
                        status: "active",
                      });
                    }}
                    className={`btn ${filter?.status === "active" ? "active" : ""} ng-star-inserted`}
                    data-tab-current={
                      filter?.status === "active" ? "current" : ""
                    }
                  >
                    <div _ngcontent-serverapp-c1328719065 className="text">
                      {t("Active")}
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c1328719065
                    onClick={() => {
                      setFilter({
                        ...filter,
                        status: "completed",
                      });
                    }}
                    className={`btn ${filter?.status === "completed" ? "active" : ""} ng-star-inserted`}
                    data-tab-current={
                      filter?.status === "completed" ? "current" : ""
                    }
                  >
                    <div _ngcontent-serverapp-c1328719065 className="text">
                      {t("Completed")}
                    </div>
                  </div>
                </div>
                <div
                  _ngcontent-serverapp-c1328719065
                  className="tab-btn-page-underline"
                />
              </app-tab-button-nav>
            </div>
          </div>
          <div
            _ngcontent-serverapp-c2794537353
            className="tab-content tab-content-page ng-tns-c2794537353-13"
          >
            <div
              _ngcontent-serverapp-c2794537353
              className="ng-tns-c2794537353-13 ng-trigger ng-trigger-tabPageTriggerAni"
            >
              <router-outlet
                _ngcontent-serverapp-c2794537353
                className="ng-tns-c2794537353-13"
              />
              <ng-component
                _nghost-serverapp-c3114357537
                className="ng-tns-c3114357537-16 ng-star-inserted"
              >
                <ul
                  _ngcontent-serverapp-c221247831
                  className="cricket-list-content ng-tns-c221247831-105"
                >
                  {data?.data?.length > 0 ? (
                    data?.data?.map((res) => {
                      return (
                        <li
                          style={{ color: "white" }}
                          _ngcontent-serverapp-c3238644402
                          className={`accordion-wrap ng-tns-c3238644402-106 ng-star-inserted`}
                        >
                          <div
                            _ngcontent-serverapp-c3238644402
                            className={`accordion-header ng-tns-c3238644402-106 ng-star-inserted`}
                          >
                            <div
                              style={{ display: "block" }}
                              _ngcontent-serverapp-c3238644402
                              className="main-info ng-tns-c3238644402-106"
                            >
                              <div
                                _ngcontent-serverapp-c3238644402
                                className="title ng-tns-c3238644402-106"
                              >
                                <span
                                  _ngcontent-serverapp-c3238644402
                                  className="category-type ng-tns-c3238644402-106"
                                >
                                  {res?.isBonusTurnover
                                    ? "Bonus"
                                    : "Normal"}{" "}
                                </span>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c3238644402
                              className="betting-info ng-tns-c3238644402-106"
                            >
                              <div
                                _ngcontent-serverapp-c3238644402
                                className="avg-odds ng-tns-c3238644402-106"
                              >
                                <svg
                                  _ngcontent-serverapp-c3238644402
                                  className="item-icon ng-tns-c3238644402-106"
                                >
                                  <circle
                                    _ngcontent-serverapp-c3238644402
                                    cx={9}
                                    cy={9}
                                    r={9}
                                    className="circle ng-tns-c3238644402-106"
                                  />
                                  <use
                                    _ngcontent-serverapp-c3238644402
                                    href={"/assets/Other/icon-odds.svg"}
                                    className="icon ng-tns-c3238644402-106"
                                  />
                                </svg>
                                <strong
                                  _ngcontent-serverapp-c3238644402
                                  style={{
                                    color:
                                      res?.transactionType === "credit"
                                        ? "green"
                                        : "red",
                                  }}
                                >
                                  {Number(res?.originalAmount).toFixed(2)}
                                </strong>
                                <span
                                  _ngcontent-serverapp-c3238644402
                                  className="ng-tns-c3238644402-106"
                                >
                                  Original Amount
                                </span>
                              </div>

                              <div
                                _ngcontent-serverapp-c3238644402
                                className="avg-odds ng-tns-c3238644402-106"
                              >
                                <svg
                                  _ngcontent-serverapp-c3238644402
                                  className="item-icon ng-tns-c3238644402-106"
                                >
                                  <circle
                                    _ngcontent-serverapp-c3238644402
                                    cx={9}
                                    cy={9}
                                    r={9}
                                    className="circle ng-tns-c3238644402-106"
                                  />
                                  <use
                                    _ngcontent-serverapp-c3238644402
                                    href={"/assets/Other/icon-odds.svg"}
                                    className="icon ng-tns-c3238644402-106"
                                  />
                                </svg>
                                <strong _ngcontent-serverapp-c3238644402>
                                  {res?.usedAmount > 0 &&
                                  res?.usedAmount != Number(res?.originalAmount)
                                    ? Number(res?.usedAmount).toFixed(2)
                                    : ""}
                                </strong>
                                <span
                                  _ngcontent-serverapp-c3238644402
                                  className="ng-tns-c3238644402-106"
                                >
                                  Amount
                                </span>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c3238644402
                              className="bet-bid ng-tns-c3238644402-106"
                            >
                              Status :
                              <span
                                _ngcontent-serverapp-c3238644402
                                className="ng-tns-c3238644402-106"
                                style={{ marginLeft: "4px" }}
                              >
                                {res.status}
                              </span>
                            </div>
                            <div
                              _ngcontent-serverapp-c3238644402
                              className="bet-placed ng-tns-c3238644402-106"
                            >
                              Created Time :
                              <span
                                _ngcontent-serverapp-c3238644402
                                className="ng-tns-c3238644402-106"
                                style={{ marginLeft: "4px" }}
                              >
                                {moment(res?.insertDate).format(
                                  "YYYY-MM-DD hh:mm:ss",
                                )}
                              </span>
                            </div>
                          </div>
                        </li>
                      );
                    })
                  ) : (
                    <NoData />
                  )}
                </ul>
              </ng-component>
            </div>
          </div>
        </ng-component>
      </ng-component>
    </AccountLayout>
  );
};

export default Turnover;
